import PropTypes from 'prop-types';

export const AppointmentInformation = ({ listItem }) => (
  <ul>
    <li>
      If possible arrive
      <strong> 10 minutes before </strong>
      your appointment time, as we may need you to complete a consultation card
    </li>
    <li>Following waxing or tanning treatments, we advise that you wear loose clothing</li>
    <li>
      Following nail treatments, allow up to 20 minutes for drying time and bring open-toed shoes to
      wear afterwards if your toenails are being painted
    </li>
    <li>
      Please inform your therapist of any medical conditions you have that they need to be aware of
    </li>
    <li>
      If you&apos;re booking any treatments as a gift for someone else, we&apos;ll call you within
      48 hours to take payment
    </li>
    {listItem}
  </ul>
);

AppointmentInformation.propTypes = {
  listItem: PropTypes.node.isRequired,
};
